var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"navlink mx-2 sm:mx-4 sm:w-16 flex flex-col items-center transition\n  hover:text-primary focus:text-primary",attrs:{"to":_vm.path}},[_c('i',{class:['fas fa-lg', _vm.iconClass]}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }